import { useNavigate } from "react-router-dom";
import { Styled } from "./styles";
import { getRoutes } from "@/utils/helpers";
import { useState } from "react";
import { Add } from "@dippi/icons";
import { Product } from "@/types/entities";
import { classificationCodeToName } from "@/utils/classification/names";
import { classificationCodeToIcon } from "@/utils/classification/icons";
import { Box, Typography, Button } from "@mui/material";
import useQuerySubscription from "@/hooks/queries/useQuerySubscription";

const CustomToolbar: React.FC = () => {
    const navigate = useNavigate();
    const routes = getRoutes();

    const onCreateProduct = (typeName: Product["typeName"]) => {
        navigate(routes.productSettings(typeName));
    };
    const [modal, setModal] = useState(false);
    const openModal = () => setModal(true);
    const closeModal = () => setModal(false);

    const { data: subscription } = useQuerySubscription();

    const hasProductGroups = subscription && subscription.productGroups.length > 0;

    return (
        <Styled.GridToolbar>
            <Button
                data-testid="new-product-button"
                type="button"
                onClick={openModal.bind(this)}
                startIcon={<Add />}
                sx={{
                    padding: "8px 16px 8px 8px",
                }}
                disabled={!hasProductGroups}
            >
                New product
            </Button>
            <Styled.Modal open={modal} onClose={closeModal.bind(this)}>
                <Styled.List maxHeight="400px" padding="10px 16px">
                    {Object.entries(classificationCodeToName)
                        .filter(i => {
                            const code = i[0];
                            if (subscription?.productGroups.includes(code)) return true;
                            return false;
                        })
                        .map(i => {
                            const code = i[0] as Product["typeName"];
                            const name = i[1];
                            const Icon = classificationCodeToIcon[code];

                            const onOpenLink = (
                                e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
                            ) => {
                                const infoURL = `https://showvoc.op.europa.eu/#/datasets/ESTAT_Statistical_classification_of_products_by_activity,_2.1_%28CPA_2.1%29/data?resId=http:%2F%2Fdata.europa.eu%2Fehl%2Fcpa21%2F${code.replace(
                                    /\./g,
                                    "",
                                )}`;
                                e.stopPropagation();
                                window.open(infoURL, "_blank");
                            };

                            return (
                                <Styled.ListItem
                                    key={code}
                                    onClick={onCreateProduct.bind(this, code)}
                                    data-testid={name.title}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Styled.IconContainer>{Icon}</Styled.IconContainer>
                                        <Box display="flex" flexDirection="column" marginLeft="5px">
                                            <Typography>{name.title}</Typography>
                                            {name.subtitle ? (
                                                <Styled.Subtitle variant="caption" fontWeight={300}>
                                                    {name.subtitle}
                                                </Styled.Subtitle>
                                            ) : null}
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="column">
                                        <Typography>Code</Typography>
                                        <Styled.Link onClick={onOpenLink}>
                                            <Typography variant="caption" fontWeight={300}>
                                                {code}
                                            </Typography>
                                        </Styled.Link>
                                    </Box>
                                </Styled.ListItem>
                            );
                        })}
                </Styled.List>
            </Styled.Modal>
        </Styled.GridToolbar>
    );
};

export default CustomToolbar;
